import http from '@/libs/AxiosPlugin'

const router = {
  list () {
    return http.get('/router/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'router1', linkType: 0, cardNo: '778721', serverAddr: 'router.eweaving.com', remark: ''},
    //     {id: 2, name: 'router2', linkType: 0, cardNo: '883525', serverAddr: 'router.eweaving.com', remark: ''}
    //   ]
    //   resolve(data)
    // })
  },

  delete (id) {
    return http.post('/router/delete', {id})
  },

  get (id) {
    return http.post('/router/get', {id})
  },

  save (router) {
    return http.post('/router/save', router)
  },

  collectorsTmSet (id) {
    return http.post('/router/collectorsTmSet', {id})
  }
}

export default router



// WEBPACK FOOTER //
// ./src/api/router.js